import initTooltips from "./components/tooltips";
import initOrderApp from "./screens/order";
import { initGiftCardOrderApp } from "./screens/gift_card_order";
initOrderApp(process.env.DADATA_API_KEY);
initGiftCardOrderApp();
initTooltips();
